<template>
  <div class="">
    <div class="row">
      <div class="col-md-12 col-sm-8">
        <div class="card card-default widget animated">
          <div class="card-heading">
            <div class="form-group">
              <p style="font-size:20px">Oooh you tried to navigate to a page your not allowed too use...</p>
              <p style="font-size:5px">We know you did this   •`_´•</p>
            </div>
          </div>
          <div class="card-body">
            
          </div>
        </div>
      </div><!-- /.col-md-9 -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'pagenotallowed',
  data () {
    return {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// PageNotAllowed.vue?2d25b46d